import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import { IoMdCheckmark } from "react-icons/io";
import { FaXmark } from "react-icons/fa6";

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Contained Quantity',
    dataIndex: 'contained_quantity',
    key: 'contained_quantity',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Sales',
    dataIndex: 'sales',
    key: 'sales',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <>{record.sales === 1 ? <IoMdCheckmark color='green' size={'1.3rem'}/> : <FaXmark color='red' size={'1.3rem'}/>}</>
  },
  {
    title: 'Purchase',
    dataIndex: 'purchase',
    key: 'purchase',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <>{record.sales === 1 ? <IoMdCheckmark color='green' size={'1.3rem'}/> : <FaXmark color='red' size={'1.3rem'}/>}</>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/packaging/'+record.name.replace(/ /g, '-').toLowerCase()}>
        EDIT
      </Link>
    )
  }
]


const ProductPackagings = () => {
  const productPackages = useLoaderData();
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Product Packagings</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/inventory/packaging/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        dataSource={productPackages}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default ProductPackagings;